import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import CommonModal from 'components/elements/modals/CommonModal';
import ChangePasswordForm
  from 'components/dashboard/security-content/ChangePasswordForm';

import './ChangePasswordModal.scss';


function ChangePasswordModal(props) {
  const {  open, onClose, changePasswordSuccess } = props;
  const { t } = useTranslation();

  return (
    <CommonModal
      className="change-password-modal__component"
      open={open}
      onClose={onClose}
    >
      <div className="header">{t("Change your password")}</div>
      {!changePasswordSuccess &&
        <ChangePasswordForm />
      }

      {changePasswordSuccess &&
        <div className="success-message">
          {t("You have changed your password")}
        </div>
      }
      <div
        className="cancel-button"
        onClick={onClose}
        role="button"
        tabIndex={-1}
      >
        {!changePasswordSuccess ? t("Cancel") : t("Close")}
      </div>
    </CommonModal>
  );
}

ChangePasswordModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
  changePasswordSuccess: PropTypes.object,
};

ChangePasswordModal.defaultProps = {
  open: null,
  changePasswordSuccess: null,
};

const mapStateToProps = state => (
  {
    changePasswordSuccess: state.usersReducer.changePasswordSuccess,
  }
);

export default connect(
  mapStateToProps,
  {},
)(ChangePasswordModal);
